import * as NUMBER from 'constant/number'
import * as FIELD_NAME from 'constant/form-item-names'
import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { editArticle, getArticleDescription } from 'action/article'
import { Form, Modal } from 'antd'
import PropTypes from 'prop-types'
import ArticleForm from 'view/page/article-management/component/article-form'
import FormModal from 'view/component/form-modal'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: `${response.title} has been successfully edited${response.is_draft ? ' and saved as a draft.' : '.'}`,
  title: 'Article edited'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'An Error has occured'
})

const EditArticle = ({ article, editArticle, getArticleDescription, submitting }) => {
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()

  const handleClick = () => {
    setVisible(true)
    getArticleDescription(article.uuid)
  }

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      const descriptionMeta = form.getFieldValue(FIELD_NAME.DESCRIPTION_META)
      const response = await editArticle({ ...values, description_meta: descriptionMeta, template_uuid: form.getFieldValue(FIELD_NAME.TEMPLATE_UUID), uuid: article.uuid })
      setVisible(false)
      !response.error ? success(buildSuccessObject(response)) : error(buildErrorObject(response))
    }).catch(({ errorFields }) => errorFields && form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
  }

  return (
    <><a onClick={handleClick}>Edit Article</a>
      <FormModal
        handleSubmit={handleSubmit}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          form.setFieldsValue(article)
        }}
        title='Edit Article'
        visible={visible}
        width={NUMBER.EIGHTEEN_HUNDRED}
      >
        <ArticleForm
          article={article}
          form={form}
        />
      </FormModal></>
  )
}

EditArticle.propTypes = {
  article: PropTypes.object,
  editArticle: PropTypes.func,
  getArticleDescription: PropTypes.func,
  submitting: PropTypes.bool
}

const mapStateToProps = (state) => ({
  submitting: state.loader.articleSubmitting
})

const mapDispatchToProps = (dispatch) => ({
  editArticle: bindActionCreators(editArticle, dispatch),
  getArticleDescription: bindActionCreators(getArticleDescription, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(EditArticle)
